import { render, staticRenderFns } from "./InGameSumoBall.vue?vue&type=template&id=c8c36020&scoped=true&"
import script from "./InGameSumoBall.vue?vue&type=script&lang=js&"
export * from "./InGameSumoBall.vue?vue&type=script&lang=js&"
import style0 from "./InGameSumoBall.vue?vue&type=style&index=0&id=c8c36020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c36020",
  null
  
)

component.options.__file = "InGameSumoBall.vue"
export default component.exports